import React from 'react';
import { motion } from 'framer-motion';
interface SectionWrapperProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}
export function SectionWrapper({
  children,
  className = '',
  id
}: SectionWrapperProps) {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className={`py-8 md:py-20 px-4 md:px-8 max-w-7xl mx-auto w-full ${className}`} data-id="element-187">
      {children}
    </motion.section>;
}